import { PropertyType } from '../../../common';

export const mapApiToEntity = (data: PropertyType): PropertyType[] => {
	const filters = data[0].filters;
	return Object.keys(filters).map((key) => ({ name: key, value: filters[key] }));
};

export const mapEntityToApi = (data: PropertyType): PropertyType => ({
	sid: data.token,
	id: data.id,
});
